var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[(!_vm.notfound)?_c('h3',[_vm._v("Redirecting...")]):_c('h3',[_vm._v("İstifadəçi tapılmadı")])])}
var staticRenderFns = []

export { render, staticRenderFns }